import { AxiosPromise } from 'axios';
import request from '@/utils/request';

import type { ConfigurationVo, RoutAllType, UploadVo, listVo } from './types.ts';

/**
 * 多语言 & 币种
 */
export const configuration = (): AxiosPromise<ConfigurationVo> => {
  return request({
    url: '/system/app/configuration',
    method: 'get'
  });
};
// 上传文件
export const upload = (data: { business: string }): AxiosPromise<UploadVo> => {
  return request({
    url: '/resource/app/oss/upload',
    method: 'post',
    data
  });
};

// 查询OSS对象基于id串
export function listByIds(params: { resource: string }): AxiosPromise<listVo[]> {
  return request({
    url: '/resource/app/oss/list',
    method: 'get',
    params
  });
}

// 删除OSS对象存储
export function delOss(params: { resource: string }): AxiosPromise<boolean> {
  return request({
    url: '/resource/app/oss/remove',
    method: 'delete',
    params
  });
}

// 动态路由所有 路由
export function gameServiceRouter(): AxiosPromise<RoutAllType[]> {
  return request({
    url: '/product/api/seo/gameServiceRouter',
    method: 'get'
  });
}
// 获取路由最后一次刷新时间
export function refreshTimeRouter(): AxiosPromise<number> {
  return request({
    url: '/product/api/seo/refreshTime',
    method: 'get'
  });
}
